$(document).ready(function(){
	var scroll = new SmoothScroll('a[href*="#"]', {
		speed: 500,
	});
	
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#select_pkg").offset().top - 50
		}, 2000);
	});
	
	//accordion JS 
	$(".accordion").click(function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn_content');
		var idx = $('.acdn_content').index(answerDiv);
		
		$('.acdn_content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.accordion').removeClass('accordion_open');
				});
			}
        });
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion_open');
			});
		} else {
		  questionDiv.addClass('accordion_open');
		  answerDiv.stop().slideDown(500);
		}
	});
	
	$('.ingredient_row').slick({
		dots: false,
		slidesToScroll: 1,				
		autoplaySpeed:0,
		arrows: false,
		responsive: [
		{
			breakpoint: 9999,
			settings: "unslick"
		},
		{
		breakpoint: 767,
		settings: {
			dots: true,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: true,
			centerMode: true,
			}
		}
		]
	});
	
	$('.review_sec').slick({
		dots: false,
		slidesToScroll: 1,				
		autoplaySpeed:0,
		arrows: false,
		responsive: [
		{
			breakpoint: 9999,
			settings: "unslick"
		},
		{
		breakpoint: 767,
		settings: {
			dots: false,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: true,
			centerMode: true,
			}
		}
		]
	});
	
			
});

$(document).scroll(function() {
		
	if ($(this).scrollTop() > 110){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
});



//MODAL POPUP JS
$(document).on('click', '#app_common_modal_close', function() {
	$('#app_common_modal').remove();
});	
function openNewWindow(page_url, type, window_name, width, height, top, left, features) {
    if (!type) {
        type = 'popup';
    }
    if (!width) {
        width = 480;
    }
    if (!height) {
        height = 480;
    }
    if (!top) {
        top = 50;
    }
    if (!left) {
        left = 50;
    }
    if (!features) {
        features = 'resizable,scrollbars';
    }

    if (type == 'popup') {
        var settings = 'height=' + height + ',';
        settings += 'width=' + width + ',';
        settings += 'top=' + top + ',';
        settings += 'left=' + left + ',';
        settings += features;

        win = window.open(page_url, window_name, settings);
        win.window.focus();
    } else if (type == 'modal') {
        var html = '';
        html += '<div id="app_common_modal">';
        html += '<div class="app_modal_body"><a href="javascript:void(0);" id="app_common_modal_close">X</a><iframe src="' + page_url + '" frameborder="0"></iframe></div>';
        html += '</div>';

        if (!$('#app_common_modal').length) {

            $('body').append(html);
        }
        $('#app_common_modal').fadeIn();
    }

}

//MODAL Shades
function openModal() {
  document.getElementById('shadeModal').style.display = 'block';
}

function closeModal() {
  document.getElementById('shadeModal').style.display = 'none';
}

// Optional: Close the modal if the user clicks outside of it
window.onclick = function(event) {
  let modal = document.getElementById('shadeModal');
  if (event.target == modal) {
    closeModal();
  }
}